import * as types from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    entity: null
};

export const setSelectedDive = (state, action) => {
    return {
        entity: action.selectedDive
    };
};

const handlers = {
    [types.SET_SELECTED_DIVE]: setSelectedDive
};

export const getSelectedDive = (state) => {
    return {
        entity: state.selectedDive
    };
};

export default function selectedDive(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
